module.exports = __webpack_public_path__ + "static/media/md-options.72fe8b50.svg";